const profile = {
    "LBL_PAGE_TITLE":"Profilul meu",
    "LBL_EDIT_PAGE_TITLE":"Profilul meu",
    "LBL_PHONE":"Telefon",
    "LBL_SKYPE":"Skype",
    "LBL_DOB":"Data nașterii",
    "LBL_AUDIO_ENABLED":"Audio",
    "LBL_EMAIL":"Email",
    "LBL_PASSWORD":"Parola",
    "LBL_LANGUAGE":"Limba",
    "LBL_GENDER":"Genul",
    "LBL_CHANGE_PASSWORD":"Schimbați parola",
    "LBL_FIRST_NAME":"Nume",
    "LBL_LAST_NAME":"Prenume",
    "LBL_EDIT_PROFILE_HEADER":"Redactează profilul",
    "LBL_CURRENT_PASSWORD":"Parola curentă",
    "LBL_EMAIL_NOT_PASSED":"Verificați adresa de e-mail",
    "LBL_EMAIL_NOT_PASSED_DESCRIPTION":"Vă rugăm să verificați dacă ați introdus corect adresa de e-mail",
    "LBL_NAME_NOT_PASSED":"Numele este obligatoriu",
    "LBL_NAME_NOT_PASSED_DESCRIPTION":"Vă rugăm să introduceți numele și prenumele",
    "LBL_NEW_EMAIL":"Introduceți adresa de email nouă",
    "LBL_CONFIRM_NEW_EMAIL":"Reintroduceți adresa de e-mail nouă",
    "LBL_NEW_PASSWORD":"Introduceți parola nouă",
    "LBL_CONFIRM_NEW_PASSWORD":"Reintroduceți parola nouă",
    "LBL_ERROR_UPDATING_PROFILE":"Actualizarea profilului nu a reușit",
    "LBL_ATTACH_SOCIAL_NETWORKS_TITLE":"Conectarea prin rețele de socializare",
    "LBL_CONNECT_NETWORK":"Conectează",
    "LBL_NETWORK_CONNECTED":"Conectat",
    "LBL_COULDNT_CONNECT_NETWORK":"Profilul nu este conectat",
};
export default profile